import { I18n } from "aws-amplify/utils";
import { translations } from "@aws-amplify/ui";

/**
 * Amplify UI Authenticator の日本語翻訳を初期化する。
 * 組み込み辞書をベースに、プロジェクト固有のオーバーライドを適用。
 */
export function initAuthenticatorI18n() {
  I18n.putVocabularies(translations);
  I18n.setLanguage("ja");

  I18n.putVocabulariesForLanguage("ja", {
    // --- サインイン → ログイン 用語統一 ---
    "Sign In": "ログイン",
    "Sign in": "ログイン",
    "Signing in": "ログイン中",
    "Sign in to your account": "アカウントにログイン",
    "Back to Sign In": "ログインに戻る",
    "Confirm Sign In": "ログインする",

    // --- サインアップ ---
    "Create Account": "新規登録",
    "Create account": "新規登録",
    "Create a new account": "新規アカウント登録",
    "No account? ": "",
    "Have an account? ": "",
    "Sign Up": "新規登録",
    "Creating Account": "登録中",
    "Confirm Sign Up": "確認する",

    // --- パスワード ---
    "Forgot your password?": "パスワードをお忘れですか？",
    "Forgot Password": "パスワードをお忘れですか？",
    "Enter your password": "パスワードを入力",
    "Enter your Password": "パスワードを入力",
    "Please confirm your Password": "パスワードを再入力してください",
    "Change Password": "パスワードを変更",
    Password: "パスワード",
    "New password": "新しいパスワード",
    "New Password": "新しいパスワード",
    "Reset your Password": "パスワードをリセット",
    "Reset your password": "パスワードをリセットする",
    "Reset password": "パスワードをリセット",
    "Reset Password": "パスワードをリセット",
    "Send code": "コードを送信",
    "Send Code": "コードを送信",
    Submit: "送信",

    // --- メールアドレス ---
    "Enter your email": "メールアドレス",
    "Enter your Email": "メールアドレス",
    Email: "メールアドレス",

    // --- 確認コード ---
    Code: "確認コード",
    "Confirmation Code": "確認コード",
    "Enter your code": "確認コードを入力",
    "We Emailed You": "確認コードを送信しました",
    "We Sent A Code": "確認コードを送信しました",
    "Your code is on the way. To log in, enter the code we emailed to":
      "確認コードをメールで送信しました。以下のアドレスに届いたコードを入力してください:",
    "Your code is on the way. To log in, enter the code we sent you":
      "確認コードを送信しました。届いたコードを入力してください",
    "It may take a minute to arrive.": "届くまで数分かかる場合があります。",

    // --- Cognito エラーメッセージ（文言は共有辞書 v2 に統一。末尾ピリオド有無の両方を登録） ---
    "Incorrect username or password.": "メールアドレスまたはパスワードが間違っています",
    "Incorrect username or password": "メールアドレスまたはパスワードが間違っています",
    "User does not exist.":
      "アカウントが見つかりません。入力内容をご確認いただくか、新規登録をお願いします",
    "User does not exist":
      "アカウントが見つかりません。入力内容をご確認いただくか、新規登録をお願いします",
    "An account with the given email already exists.":
      "このメールアドレスは登録済みです。ログイン画面からログインをお試しください",
    "An account with the given email already exists":
      "このメールアドレスは登録済みです。ログイン画面からログインをお試しください",
    "Invalid verification code provided, please try again.": "確認コードが正しくありません",
    "Attempt limit exceeded, please try after some time.":
      "試行回数の上限を超えました。しばらく時間をおいてから再度お試しください",
    "Attempt limit exceeded, please try after some time":
      "試行回数の上限を超えました。しばらく時間をおいてから再度お試しください",
    "Password attempts exceeded":
      "試行回数の上限に達しました。しばらく時間をおいて再度お試しください",
    "User already exists":
      "このメールアドレスは登録済みです。ログイン画面からログインをお試しください",
    "Username cannot be empty": "メールアドレスを入力してください",
    "User is not confirmed.":
      "登録が未完了です。メールに届いた認証コードを入力し、登録を完了してください",
    "User is not confirmed":
      "登録が未完了です。メールに届いた認証コードを入力し、登録を完了してください",
    "Password is required": "パスワードを入力してください",
    "Confirm Password is required": "確認用パスワードを入力してください",

    // --- 二段階認証（MFA） ---
    "MFA method not found": "二段階認証の設定が見つかりません。管理者にお問い合わせください",
    "Software token MFA not found":
      "二段階認証の設定が見つかりません。管理者にお問い合わせください",

    // --- パスワードポリシー違反エラー（本プロジェクト: 小文字・数字・記号を含む10文字以上） ---
    "Password did not conform with policy: Password not long enough":
      "パスワードは小文字、数字、記号を含む10文字以上で入力してください",
    "Password did not conform with policy: Password must have lowercase characters":
      "パスワードには小文字を含めてください",
    "Password did not conform with policy: Password must have numeric characters":
      "パスワードには数字を含めてください",
    "Password did not conform with policy: Password must have symbol characters":
      "パスワードには記号を含めてください",
    // does not conform to policy 系（リセット/新パスワード設定フローで返る変種。今回の英語表示の直接原因）
    "Password does not conform to policy: Password not long enough":
      "パスワードは小文字、数字、記号を含む10文字以上で入力してください",
    "Password does not conform to policy: Password must have lowercase characters":
      "パスワードには小文字を含めてください",
    "Password does not conform to policy: Password must have numeric characters":
      "パスワードには数字を含めてください",
    "Password does not conform to policy: Password must have symbol characters":
      "パスワードには記号を含めてください",
    "Password does not conform to policy":
      "パスワードは小文字、数字、記号を含む10文字以上で入力してください",
    "Invalid password format": "パスワードは小文字、数字、記号を含む10文字以上で入力してください",

    // --- クライアント側パスワードバリデーション ---
    "Password must have at least 8 characters":
      "パスワードは小文字、数字、記号を含む10文字以上で入力してください",
    "Password must have numbers": "パスワードには数字を含めてください",
    "Password must have special characters": "パスワードには記号を含めてください",
    "Password must have lower case letters": "パスワードには小文字を含めてください",
    "Password must have upper case letters": "パスワードには大文字を含めてください",

    // --- パスワード確認エラー ---
    "Passwords must match": "パスワードが一致しません",
    "Your passwords must match": "パスワードが一致しません",

    // --- 確認コードエラー ---
    "Code mismatch": "確認コードが正しくありません",
    CodeMismatchException: "確認コードが正しくありません",
    "Expired code": "確認コードの有効期限が切れています",
    ExpiredCodeException: "確認コードの有効期限が切れています",
    "Code delivery failure":
      "確認コードの送信に失敗しました。ご登録の連絡先が正しいかご確認ください",

    // --- パスワードリセット要求 ---
    "Password reset required": "パスワードのリセットが必要です",
    PasswordResetRequiredException: "パスワードのリセットが必要です",

    // --- セキュリティ・制限 ---
    "Too many failed attempts":
      "アカウントが一時的にロックされました。時間を置くか、パスワードを再設定してください",
    "Too many requests, please try again later":
      "操作が一時的に制限されています。しばらく時間をおいてから再度お試しください",

    // --- システムエラー ---
    "Internal server error":
      "システムエラーが発生しました。しばらく経ってから再度お試しいただくか、管理者へお問い合わせください",
    "Invalid lambda function output":
      "システムエラーが発生しました。しばらく経ってから再度お試しいただくか、管理者へお問い合わせください",
    "Invalid user pool configuration":
      "システムエラーが発生しました。しばらく経ってから再度お試しいただくか、管理者へお問い合わせください",

    // --- その他の一般的なエラー ---
    "Invalid parameter": "無効なパラメータです",
    InvalidParameterException: "無効なパラメータです",
    "Invalid email address format": "メールアドレスの形式が正しくありません",
    "Limit exceeded": "試行回数の上限に達しました。しばらく時間をおいて再度お試しください",
    LimitExceededException: "試行回数の上限に達しました。しばらく時間をおいて再度お試しください"
  });
}
